export default __webpack_public_path__ + "static/banner-computer-69c18344416276f281705916e0fe2246.png";